import React, { Component } from "react";
import CommerceList from "./section-commerce-list";

import { Container, Row, Col, Image, Button } from "react-bootstrap";
import FormSeach from "./section-form";
import Map from "./section-map";
import GeoLocation from "../../actions/getLocation";
import WokkoCercaDeMi from "../../actions/wokkocercca";
import "./commerce.css";
import ups from '../../assets/images/ups.svg';
import loadingImage from '../../assets/images/loading.gif';

class CommerceSearch extends Component {
  state = {
    commerces: [],
    selectedCommerce: null,
    message: "",
    loading: false,
  };

  array_move = (arr, old_index, new_index) => {
    if (new_index >= arr.length) {
      let k = new_index - arr.length + 1;
      while (k--) {}
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr;
  };

  onSearchSubmit = (data) => {
    this.setState({ commerces: data });
    this.setState({ selectedCommerce: data[0] });
  };

  onCommerceSelect = (commerce) => {
    this.setState({ selectedCommerce: commerce });
  };

  updateMessage = (text) => {
    this.setState({ ...this.state, message: text });
  };

  toggleLoading = (status) => {
    this.setState({ ...this.state, loading: status });
  };

  findShops = async () => {
    this.toggleLoading(true);
    const gl = new GeoLocation();
    const geolocation = await gl
      .getLocation()
      .then((position) => {
        const coords = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
        return coords;
      })
      .catch((_) => {
        const coords = {
          lat: 19.4418399,
          lng: -99.2039108,
        };
        return coords;
      });
    const getCommercers = new WokkoCercaDeMi({
      REACT_APP_UAT_CERCADEMI_ENDPOINT:
        process.env.REACT_APP_UAT_CERCADEMI_ENDPOINT,
    });
    let restult_commerces = await getCommercers.fetchCommerces(
      geolocation.lat,
      geolocation.lng
    );
    restult_commerces = restult_commerces.filter( commerce => commerce.id);
    const ordered_commerces = [...this.array_move(restult_commerces, 0, 1)];
    this.setState({ commerces: ordered_commerces });
    this.setState({ selectedCommerce: ordered_commerces[0] });
    this.toggleLoading(false);

  };

  render() {
    return (
      <React.Fragment>
        <Container className="text-center container-search">
          <Row>
            <Col className="py-3 container-search-global">
              <p className="text-left">
                Hola, ingresa una dirección y selecciona lo que quieres hacer o
                explora todas las posibilidades presionando el botón "Buscar
                cerca de mí".
              </p>
              <Button
                variant="button-round"
                type="submit"
                className="btn-button-round-search"
                onClick={this.findShops}
              >
                Buscar Cerca de Mí
              </Button>
            </Col>
          </Row>

          <Row className="m-4 p-3 container-search-controls">
            <Col>
              <FormSeach
                onSearchSubmit={this.onSearchSubmit}
                updateText={this.updateMessage}
                toggleLoading={this.toggleLoading}
              />
            </Col>
          </Row>

          <Row className="text-left result-map">
            <Col sm={12} md={6} className="mb-3 list-result">
              {this.state.loading && (
                <Image
                  className="img-loading"
                  src={loadingImage}
                  width="300"
                  height="200"
                />
              )}
              {!this.state.loading &&
                (this.state.commerces.length === 0 ? (
                  <div className="loading">
                    <p>
                      {" "}
                      {this.state.message
                        ? this.state.message
                        : "Aún no has seleccionado ninguna opción."}{" "}
                    </p>
                    <Image src={ups} width="300" height="200" />
                  </div>
                ) : (
                  <div className="results">
                    <CommerceList
                      commerces={this.state.commerces}
                      onCommerceSelect={this.onCommerceSelect}
                    />
                  </div>
                ))}
            </Col>
            <Col sm={12} md={6} className="mb-3 list-result">
              <Map commerce={this.state.selectedCommerce} />
            </Col>
          </Row>
          <Row>
            <Col className="count-results">
              {this.state.commerces.length} resultados
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default CommerceSearch;
